import { Component, EventEmitter, Output } from '@angular/core';
import { Router } from '@angular/router';

@Component({
  selector: 'rosie-lead-sources-banner',
  templateUrl: './lead-sources-banner.component.html',
  styleUrls: ['./lead-sources-banner.component.scss'],
  standalone: false,
})
export class LeadSourcesBannerComponent {
  @Output() dismissed = new EventEmitter<void>();

  constructor(private router: Router) {}

  dismiss(): void {
    this.dismissed.emit();
  }

  navigate(): void {
    this.router.navigate(['/integrations']);
  }
}
